(function () {
  if (typeof global === "undefined") {
    window.global = window;
  }
})();
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "react-google-flight-datepicker/dist/main.css";
import "rsuite/dist/rsuite.min.css";
import { Provider } from "react-redux";
import store from "./store/store.ts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";
// @ts-ignore
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

try {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
  });
  console.log(mixpanel);
} catch (error) {
  console.log("Failed to initialize Mixpanel:", error);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="675097151498-r3dtmum7c9d3db37tkdkcao68m0cpnhn.apps.googleusercontent.com">
        <ToastContainer />

        <App />
      </GoogleOAuthProvider>
    </Provider>
  </HelmetProvider>
);
